import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'

import { store } from 'store'
import { ScrollTop } from 'components/scrollTop/ScrollTop'
import { AppHeader } from 'containers/common/appHeader/AppHeader'
import { FeedbackPage } from 'containers/pages/feedback/FeedbackPage'
import { SubmittedPage } from 'containers/pages/submitted/SubmittedPage'

const App = () => (
  <Provider store={store}>
    <Router>
      <ScrollTop>
        <AppHeader />

        <Switch>
          <Route exact path="/feedback" component={FeedbackPage} />
          <Route exact path="/submitted" component={SubmittedPage} />

          <Redirect from="/*" to="/submitted?type=NO_FORM" />
        </Switch>
      </ScrollTop>
    </Router>
  </Provider>
)

export default App
